// extracted by mini-css-extract-plugin
module.exports = {"title-default":"Title_title-default__bm012","title-small":"Title_title-small__70JQk"};